import { createRef } from 'react';

import {
  useTranslate ,
  Button   
} from 'react-admin';

import SaveIcon from '@material-ui/icons/GetApp';

import { headersAPIObjectAuth } from './../common/utils';


export function DownloadButtonAuth ({ ...props}) {
  const link = createRef();
  const translate = useTranslate(); 

  const handleAction = async () => {
    if (link.current.href) { return; }  

    const result = await fetch(props.record.url, {
      headers: headersAPIObjectAuth()
    });
    
    const blob = await result.blob();
    const href = window.URL.createObjectURL(blob);
    
    link.current.download = props.record.name;
    link.current.href = href;
      
    link.current.click();
  };

  return (
    <a role='button' ref={link} onClick={handleAction} style={{ textDecoration: 'none' }}>
      <Button label={props.label} startIcon={<SaveIcon />} />
    </a>
  );

}
